module.exports = __webpack_public_path__ + "img/chevron-right.d3400afd.svg";